import { render, staticRenderFns } from "./DefinirSenha.vue?vue&type=template&id=03ff47ca&scoped=true"
import script from "./DefinirSenha.vue?vue&type=script&lang=js"
export * from "./DefinirSenha.vue?vue&type=script&lang=js"
import style0 from "./DefinirSenha.vue?vue&type=style&index=0&id=03ff47ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff47ca",
  null
  
)

export default component.exports